<template>
  <PMain v-model="themeData" :dataKey="key">
    <v-row>
      <v-col v-if="sessionData && sessionData.data && !isLoading">
        <v-alert type="error" v-if="!isQrValid">
          QR Code not valid, please contact our staff to get latest QR Code
        </v-alert>
        <v-card v-else :loading="isLoading">
          <v-alert type="warning" v-if="willExpiresIn == null">
            Loading ...
          </v-alert>
          <v-alert type="error" v-else-if="willExpiresIn !== null && isExpired">
            Your session is expired!
          </v-alert>
          <v-alert type="info" v-else>
            Your will be redirected to {{ nextUrl }}
          </v-alert>
        </v-card>
      </v-col>
      <v-col v-else>
        <v-skeleton-loader type="card"> </v-skeleton-loader>
      </v-col>
    </v-row>
  </PMain>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PMain from "../components/PMain.vue";
import comminMixin from "../mixins/common";

export default {
  mixins: [comminMixin],
  data: () => ({
    key: "redirect",
    themeData: [],
    agree: false,
    dialogSuccess: false,
    collapse: {},
    editable: false,
    productRemarkActive: {},
    orderData: {
      order_remark: null,
    },

    willExpiresIn: null,
    timer: null,
  }),
  components: {
    PMain,
  },
  async mounted() {
    await this.loadSession();
    await this.setToken();
    if (!this.sessionData.started_at) {
      await this.checkinTable();
    }
    this.startTimer();
    this.$store.commit('cart/SET_ORDER_LOADING', false);
  },
  methods: {
    ...mapActions({
      getSession: "session/getByUniqId",
      updateSession: "session/update",
      setToken: "auth/setToken"
    }),

    startTimer() {
      this.timer = window.setInterval(() => {
        this.calculate();
      }, 1000);
    },

    stopTimer() {
      clearInterval(this.timer);
    },

    async loadSession() {
      await this.getSession(this.sessionId);
    },

    async checkinTable() {
      const nowTimeInUTC = this.formatDateTime(this.getNowUTC);
      const expiredTimeInUTC = this.formatDateTime(
        this.getNowUTC.add(
          this.sessionData.data.timeLimit,
          this.sessionData.data.timeLimitUnit
        )
      );

      await this.updateSession({
        id: this.sessionData.id,
        data: {
          started_at: nowTimeInUTC,
          ended_at: null,
          // expired_at: expiredTimeInUTC,
          // order_expired_at: expiredTimeInUTC,
        },
      });
      await this.loadSession();

      // clear order data if any
      this.$store.dispatch("cart/clearAll");
    },

    calculate() {
      this.willExpiresIn = this.$store.getters["session/getRemainSecondBeforeExpired"]();
    },
  },
  watch: {
    async sessionId() {
      await this.loadSession();
    },
    isExpired() {
      if (!this.isExpired && this.isQrValid) {
        window.setTimeout(() => this.$router.push(this.nextUrl), 0);
      }
    },
  },
  computed: {
    sessionId() {
      let uniqId = null;
      if (this.$route.query && this.$route.query["sessionId"]) {
        uniqId = this.$route.query["sessionId"];
      }
      if (!uniqId && this.$route.params && this.$route.params["sessionId"]) {
        uniqId = this.$route.params["sessionId"];
      }
      return uniqId;
    },
    tableId() {
      let tableId = this.sessionData.table_id;
      if (this.$route.query && this.$route.query["table_number"]) {
        tableId = this.$route.query["table_number"];
      }
      return tableId;
    },
    isQrValid() {
      return this.tableId === this.sessionData.table_detail.number;
    },
    ...mapState({
      sessionData: (state) => state.session.data,
      isLoading: (state) => state.session.isLoading,
      auth: (state) => state.data
    }),
    isExpired() {
      if (this.willExpiresIn > 0) {
        return false;
      }
      return true;
    },
    nextUrl() {
      return `/table/${this.tableId}`;
    },
  },
};
</script>
